var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "farm-item-box" },
    _vm._l(_vm.dataList, function(item, index) {
      return _c(
        "div",
        {
          key: index,
          class: [
            "item",
            {
              "is-active": item.show,
              "is-disabled": item.wholeDisable,
              "is-use": !item.isUse
            }
          ],
          on: {
            click: e => {
              _vm.handleShowClick(item, index, e)
            }
          }
        },
        [
          _c("div", [
            item.showIcon
              ? _c("i", {
                  staticClass: "el-icon-circle-check active",
                  attrs: { title: item.tip },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.handleIconClick($event, item)
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" " + _vm._s(item.name) + " ")
          ]),
          item.tupuBtn
            ? _c("div", {
                class: [
                  "button",
                  {
                    "is-disabled": _vm.getDisabled(item)
                  }
                ],
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    _vm.handleTupuClick(item, index, _vm.getDisabled(item))
                  }
                }
              })
            : _vm._e()
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }